import { UserSettingRequest } from '@api/core';
import { DefaultLpsForPairsModel } from './shared-user-settings.interfaces';
import { LpsOrderMap } from '@shared/store/features/user-settings.feature';

export const LPS_ORDER_SETTINGS = 'LPS_ORDER_SETTINGS';

export function toLpsOrder(settings?: UserSettingRequest): LpsOrderMap {
  return settings?.value ? JSON.parse(settings?.value) : {};
}

export function toLpsOrderUserSettings(lpsOrder: LpsOrderMap): UserSettingRequest {
  return {
    key: LPS_ORDER_SETTINGS,
    value: JSON.stringify(lpsOrder),
  };
}

export const HOUSE_LP_POSITIONS_IDS = 'HOUSE_LP_POSITIONS_IDS';

export function toHouseLpPositionsIds(settings?: UserSettingRequest): number[] {
  return settings?.value ? JSON.parse(settings?.value) : [];
}

export function toHouseLpPositionsIdsUserSettings(ids: number[]): UserSettingRequest {
  return {
    key: HOUSE_LP_POSITIONS_IDS,
    value: JSON.stringify(ids),
  };
}

export const DEFAULT_LPS_FOR_PAIRS = 'DEFAULT_LPS_FOR_PAIRS';

export function toDefaultLpsForPairsModel(settings?: UserSettingRequest): DefaultLpsForPairsModel {
  return settings?.value ? JSON.parse(settings?.value) : {};
}

export function toDefaultLpsForPairsUserSettings(model: DefaultLpsForPairsModel): UserSettingRequest {
  return {
    key: DEFAULT_LPS_FOR_PAIRS,
    value: JSON.stringify(model),
  };
}
